<span class="svi-chart-legend-item">
  <svg style="vertical-align: bottom;" viewBox="0 0 20 20" width="20" height="20">
    <g>
      <circle stroke="white" stroke-width="0" cx="10" cy="10" r="10" [style.fill]="color"></circle>
    </g>
  </svg>
  &nbsp;{{label}}
</span>
